// Home page FAQ (full home interiors), grouped by topic.

// Home page FAQ (full home interiors). Grouped by topic; edit answers to match your exact terms.
export const homeFaq = {
  tag: 'FAQs',
  title: 'Questions homeowners ask us',
  highlight: 'before they start',
  subtitle: 'Everything about designing your home with Urbane Living, from the first visit to the final handover.',
  groups: [
    {
      key: 'start',
      label: 'Getting Started',
      items: [
        {
          q: 'How do I start my home interior project with Urbane Living?',
          a: 'Book a free consultation. Our designer visits your home, understands your needs and budget, takes measurements and then shares a 3D design and an itemised quote. Work starts only after you approve the design.',
        },
        {
          q: 'Do you charge for the consultation and 3D design?',
          a: 'No. The first consultation, site visit and 3D design are free, so you can see exactly how your home will look before you decide.',
        },
        {
          q: 'Which cities do you serve?',
          a: 'We work across Delhi NCR: Delhi, Noida, Greater Noida, Ghaziabad, Gurgaon and Faridabad.',
        },
        {
          q: 'Can you design a single room, or only full homes?',
          a: 'Both. You can start with one room, a modular kitchen, wardrobes or just a false ceiling, and add more rooms later in the same style.',
        },
      ],
    },
    {
      key: 'cost',
      label: 'Cost & Budget',
      items: [
        {
          q: 'How much does home interior design cost?',
          a: 'It depends on the size of your home, the rooms you choose and the materials. After the site visit you get an itemised quote, room by room, so you know where every rupee goes. False ceilings start at ₹120 per sq. ft.',
        },
        {
          q: 'Are there any hidden charges?',
          a: 'No. Your quote lists material, labour and fittings separately. Anything new is added only after you approve it in writing.',
        },
        {
          q: 'Can you work within my budget?',
          a: 'Yes. Tell us your budget at the start and our designer will suggest materials and finishes that give you the best look within it.',
        },
      ],
    },
    {
      key: 'time',
      label: 'Timeline & Process',
      items: [
        {
          q: 'How long does a full home interior take?',
          a: 'It depends on the scope of work. Your quote includes a written timeline, and a false ceiling is typically ready in just 7 days after design approval.',
        },
        {
          q: 'Will I get updates while work is going on?',
          a: 'Yes. A dedicated site supervisor manages your project and shares regular progress updates and photos on WhatsApp.',
        },
        {
          q: 'Do I need to move out during the work?',
          a: 'Usually not for one or two rooms. For a full home renovation we plan the work room by room and will tell you in advance if any area needs to be empty.',
        },
      ],
    },
    {
      key: 'quality',
      label: 'Materials & Warranty',
      items: [
        {
          q: 'What materials do you use?',
          a: 'Branded gypsum boards, GI framing, quality plywood, laminates and hardware. Your quote names the brands, so you know exactly what goes into your home.',
        },
        {
          q: 'Do you give a warranty?',
          a: 'Yes. Our false ceilings come with a 10-year anti-crack warranty, and the warranty for each item is written in your quote.',
        },
        {
          q: 'What happens if something needs repair after handover?',
          a: 'Call or WhatsApp us. Our team visits, checks the issue and fixes anything covered under warranty at no cost.',
        },
      ],
    },
    {
      key: 'ceiling',
      label: 'False Ceiling',
      items: [
        {
          q: 'Why should I get a false ceiling?',
          a: 'It hides wiring and beams, adds beautiful cove and profile lighting, improves sound and heat insulation, and instantly makes a room look premium.',
        },
        {
          q: 'Gypsum or POP: which ceiling is better?',
          a: 'Gypsum is faster to install, cleaner on site, lighter and less likely to crack, which makes it the better choice for most homes. POP suits very detailed custom shapes.',
        },
        {
          q: 'How long does a false ceiling last?',
          a: 'A well-installed gypsum ceiling with proper framing and jointing lasts 15–20 years with very little maintenance.',
        },
      ],
    },
  ],
  helpTitle: 'Still have a question?',
  helpText: 'Talk to a designer. No sales pressure, just honest answers for your home.',
};
